module.exports = __webpack_public_path__ + "static/media/avatar-17.38e741bf.svg";